export const linkCdadFilterAttributes = {
    "available_attributes": [
        {
            "odo_min": [
                [
                    7264.58
                ]
            ],
            "odo_max": [
                [
                    7337.0
                ]
            ],
            "DispatchModelType": [
                [
                    "TZNH47L-PRVSZA"
                ]
            ],
            "ModelYear": [
                [
                    "2024"
                ]
            ],
            "vehicleName": [
                [
                    "TACOMA"
                ]
            ],
            "min_timestamp": [
                [
                    "2024-11-01T16:46:13"
                ]
            ],
            "max_timestamp": [
                [
                    "2024-11-02T00:40:31"
                ]
            ],
            "VIN_count": [
                [
                    1
                ]
            ],
            "familyCd": [
                [
                    "912W"
                ]
            ],
            "line_of_date": [
                [
                    "05/2024"
                ]
            ],
            "plantAbbr": [
                [
                    "TMMBC"
                ]
            ],
            "seriesFuelTypeNm": [
                [
                    "TACOMA HYBRID"
                ]
            ],
            "modelNm": [
                [
                    "TACOMA LTD HV"
                ]
            ],
            "engineTypeCd": [
                [
                    "T24A"
                ]
            ],
            "engineCategoryNm": [
                [
                    "HYBRID"
                ]
            ],
            "engineNm": [
                [
                    "T24A-FTS"
                ]
            ],
            "driveTrainDescr": [
                [
                    "4WD"
                ]
            ],
            "transmissionDescr": [
                [
                    "8AT"
                ]
            ],
            "transmission_model": [
                [
                    "AT"
                ]
            ],
            "claim_no": [
                [
                    "339071"
                ]
            ],
            "claimed_part_no_list": [
                [
                    "*"
                ]
            ],
            "claimed_part_desc_list": [
                [
                    "*"
                ]
            ],
            "t1_cd_desc": [
                [
                    "*"
                ]
            ],
            "t2_cd_desc": [
                [
                    "*"
                ]
            ],
            "months_in_service": [
                [
                    1
                ]
            ],
            "mileage": [
                [
                    5
                ]
            ],
            "drivetrain_name": [
                [
                    "4WD"
                ]
            ],
            "engine_type": [
                [
                    "T24AFTS"
                ]
            ],
            "engine_family": [
                [
                    "T24AFTS"
                ]
            ],
            "transmission_type": [
                [
                    "8AT"
                ]
            ],
            "transmission_model_tbdp_data": [
                [
                    "HL580F"
                ]
            ],
            "plant_name": [
                [
                    "MEXICO"
                ]
            ],
            "Warranty_Ind": [
                [
                    "Y"
                ]
            ],
            "assembly_date": [
                [
                    "05/2024"
                ]
            ],
            "field_report_number": [
                [
                    "TQCN_DPR-241800097"
                ]
            ],
            "field_report_status": [
                [
                    "Complete"
                ]
            ],
            "field_report_title": [
                [
                    "24MY Tacoma - Rear seat bottom missing clip - Added missing part to seat component "
                ]
            ],
            "campaign_title": [
                [
                    null
                ]
            ],
            "ssc_campaign_cd": [
                [
                    null
                ]
            ],
            "campaign_indicator": [
                [
                    "N"
                ]
            ],
            "ftr_indicator": [
                [
                    "Y"
                ]
            ],
            "part_no": [
                [
                    "52105YY190",
                    "63101AK020",
                    "65600AK030",
                    "61012AK010",
                    "53301AK020",
                    "5710104030",
                    "67002AK010",
                    "67031AK010",
                    "67004AK010",
                    "67003AK010",
                    "5830904020",
                    "5809904140",
                    "56117AK010",
                    "5830104190",
                    "65500AK030",
                    "43220AK040",
                    "65063AK010",
                    "67128AK010",
                    "55301AK020",
                    "61102AK010",
                    "67127AK010",
                    "43210AK040",
                    "65701AK030",
                    "61011AK010",
                    "4420004080",
                    "67032AK010",
                    "67001AK010",
                    "61101AK010"
                ]
            ],
            "part_desc": [
                [
                    "PANEL SUB-ASSY, COWL SIDE, LH",
                    "GEAR ASSY, ELECTRIC POWER STRG W/TIE ROD",
                    "PLATE SUB-ASSY, RR FLOOR",
                    "PANEL SUB-ASSY, TAIL GATE, INSIDE",
                    "PANEL ASSY, RR BODY SIDE, LH",
                    "PANEL SUB-ASSY, RR DOOR, RH",
                    "PANEL SUB-ASSY, INSTRUMENT",
                    "PANEL SUB-ASSY, FR DOOR, LH",
                    "MEMBER SUB-ASSY, SIDE, OUTER RH",
                    "PANEL SUB-ASSY, RR DOOR, LH",
                    "GATE SUB-ASSY, RR BODY TAIL",
                    "PANEL SUB-ASSY, FR DOOR HINGE SIDE, LH",
                    "PANEL SUB-ASSY, ROOF",
                    "HOOD SUB-ASSY",
                    "REINFORCEMENT, RR DOOR, NO.2 RH",
                    "BUMPER SUB-ASSY, RR",
                    "MEMBER SUB-ASSY, SIDE, OUTER LH",
                    "PANEL SUB-ASSY, COWL SIDE, RH",
                    "PANEL SUB-ASSY, FR DOOR, RH",
                    "KNUCKLE ASSY, STEERING RH W/DISC BRAKE",
                    "PANEL SUB-ASSY, FR DOOR HINGE SIDE, RH",
                    "PANEL ASSY, RR BODY SIDE, RH",
                    "KNUCKLE ASSY, STEERING LH W/DISC BRAKE",
                    "PAN SUB-ASSY, FR FLOOR",
                    "PAN SUB-ASSY, RR FLOOR",
                    "CROSSMEMBER SUB-ASSY, FLOOR, NO.1",
                    "REINFORCEMENT, RR DOOR, NO.2 LH",
                    "DAM, WINDOW GLASS ADHESIVE"
                ]
            ],
            "NAMC_NM": [
                [
                    "TMMGT"
                ]
            ],
            "is_na": [
                [
                    "Y"
                ]
            ]
        }
    ]
}

export const linkCdadFilterAttributesVins = {"available_attributes": [{"vin": [["TESTVIN12345678901"]]}]}
 

export const linkCdadFilterAttributesCan = {
    "available_attributes": [
        {
            "can_signals": [
                [
                    "2E5_RLBKLMET",
                    "638_PWDRR",
                    "381_I_RRDEF",
                    "639_HDCY_BDB",
                    "0D7_SP1S",
                    "620_PCTY",
                    "0AA_VXFREF",
                    "025_STS3",
                    "381_I_REC",
                    "620_DCTY",
                    "3C6_GATHW",
                    "411_PCSSWM",
                    "2E5_DBKL_MET",
                    "2E5_RRBKLMET",
                    "3BF_B_P",
                    "638_LSWD",
                    "176_XLDR",
                    "361_EDRENG03",
                    "6E2_TPM_SPPR",
                    "622_SB_IND",
                    "08A_PCSALM",
                    "08A_PBATRGR",
                    "2F3_WVR_S",
                    "622_HEDH",
                    "3D3_B_FC",
                    "115_NE1",
                    "382_I_TMP_D",
                    "361_EDRENG04",
                    "0AA_VXFLEF",
                    "412_LKACB",
                    "412_LKAWLSR",
                    "620_SRPOS",
                    "3B0_AC_MODE",
                    "411_PCSOFFS",
                    "3BF_B_N",
                    "620_POSW",
                    "3BF_B_R",
                    "638_LSWP",
                    "101_PWCS",
                    "2F3_WLO_S",
                    "6E2_TPM_FR0",
                    "412_LDAEXIST",
                    "101_FSTP",
                    "2E5_RCBKLMET",
                    "638_LSWR",
                    "090_VSC_YAWF",
                    "251_ACCCCSID",
                    "090_VSC_GX0",
                    "63B_TRIP_CNT",
                    "2A1_B_GEAR",
                    "3B0_ACN_AMB",
                    "6E1_TPM_IND",
                    "412_LKAWTCS",
                    "2F3_WINT_S",
                    "247_EVM_MSG",
                    "638_PWDRP",
                    "025_STS2",
                    "3B6_SOC_MON",
                    "411_FSSINFO",
                    "63B_TIME_CNT",
                    "0AA_VXRLEF",
                    "51E_B_ISNW",
                    "2F3_WHI_S",
                    "101_PMCF",
                    "412_VSDGCONT",
                    "025_SSA",
                    "0AA_VXFL",
                    "51E_B_DMODE",
                    "412_LDWEXIST",
                    "116_EACCP_D",
                    "090_VSC_GYIV",
                    "025_STS1",
                    "412_SWSSWD",
                    "638_PWDRD",
                    "2F9_RRWASH",
                    "6E2_TPM_RRPR",
                    "101_PWCF",
                    "412_STRCTLD",
                    "412_VUSMONST",
                    "6E2_TPM_RL0",
                    "101_PMCS",
                    "411_PCSWM",
                    "3B0_RDEF",
                    "381_I_DEF",
                    "13B_ABSOPE",
                    "617_MET_FGI",
                    "361_EDRENG02",
                    "412_VSDGONST",
                    "622_TAIL",
                    "411_PCSMTBZ2",
                    "2F9_FRWASH",
                    "412_LDWTEXT",
                    "412_SWSEXIST",
                    "412_LDACS",
                    "411_PCSEXIST",
                    "2F9_RRWIPOPE",
                    "6E2_TPM_FLPR",
                    "6E2_TPM_FRPR",
                    "622_HEDL",
                    "620_RRCY",
                    "6E2_TPM_TAN0",
                    "101_PMC",
                    "0AA_VXRL",
                    "101_WSTP",
                    "611_ODO",
                    "412_LKAWLSL",
                    "620_PKB_BDB",
                    "090_VSC_YAW0",
                    "2F9_FRWIPOPE",
                    "412_VIBEXIST",
                    "2E5_PBKL_MET",
                    "412_VPDAONST",
                    "383_ST_CN_OK",
                    "2F3_WOFF_S",
                    "025_SSAV",
                    "090_VSC_GYF",
                    "3BF_B_D",
                    "13B_VSCACT",
                    "412_LDALSAST",
                    "2F3_WA_S",
                    "2F3_WMST_S",
                    "614_HZS",
                    "0AA_VXFR",
                    "101_PWC",
                    "090_VSC_GY0",
                    "0AA_VXRREF",
                    "0C6_FBKSYS",
                    "08A_AVSTRGR",
                    "411_PCSRTWM",
                    "6E1_TPM_DISP",
                    "6E2_TPM_RR0",
                    "51E_RDYIND",
                    "620_SREXIST",
                    "090_VSC_YAWS",
                    "638_LSWL",
                    "090_VSC_GXIV",
                    "2F3_WAI_S",
                    "116_EACCP",
                    "6E2_TPM_FL0",
                    "412_LDALSMCS",
                    "0AA_VXRR",
                    "13B_TRCOPE",
                    "614_TNS",
                    "381_I_WIPD",
                    "622_FFOG",
                    "638_PWDRL",
                    "6E2_TPM_SP0",
                    "381_I_BLW_F",
                    "411_PCSWDS",
                    "620_RLCY",
                    "0D7_SP1",
                    "412_LDAWRNC",
                    "381_I_AC",
                    "611_ODO_UNIT",
                    "6E2_TPM_RLPR",
                    "383_SL_ACDSP",
                    "251_ACCID",
                    "638_LSWB",
                    "382_I_TMP_P",
                    "412_LDACD",
                    "090_VSC_GXF",
                    "620_BCTY",
                    "0C6_BKTQA",
                    "412_LTAINDI"
                ]
            ]
        }
    ]
}

export const linkCdadFilterAttributes51F = {
    "available_attributes": [
        {
            "51f_signals": [
                [
                    "FrontBlowerLevel",
                    "WindowPositionP",
                    "PCSOpStateAlarm",
                    "FuelConsumed",
                    "TempSettingP",
                    "WindowPositionRL",
                    "TimeCount",
                    "DoorLockPositionRR",
                    "BrakePedalInd",
                    "Speed",
                    "AccelPedalAngleExControl",
                    "BrakeWheelPressure",
                    "DoorOpenD",
                    "TailLampStatus",
                    "SteeringAngle_A",
                    "PCSSetting",
                    "RearDefInd",
                    "ParkingBrake",
                    "ACInd",
                    "SeatBeltD",
                    "DoorLockPositionB",
                    "ABSControl",
                    "DefogInd",
                    "DoorLockPositionP",
                    "WaterTemp_D",
                    "AmbientTemp_B",
                    "SlideRoofExist",
                    "WheelSpeedRR",
                    "AccelFB",
                    "PCSWarningTimingSoft",
                    "TPMonitoringStateRL",
                    "VSCControl",
                    "TPMonitoringStateRR",
                    "ACStatus",
                    "RearDefState",
                    "TPMonitoringStateFL",
                    "WindowPositionD",
                    "StateOfCharge",
                    "HazardSwitch",
                    "AngularVelocity",
                    "AccelLR",
                    "SeatOccupiedP",
                    "DoorOpenB",
                    "TempSettingD",
                    "EngineRPM",
                    "HeadLamp_B",
                    "TurnSignal",
                    "DoorOpenRR",
                    "DoorLockPositionRL",
                    "WheelSpeedFL",
                    "SmartBeamInd",
                    "TirePressureSP_TypeB",
                    "FrontFogLamp",
                    "SlideRoofPosition",
                    "WiperControl",
                    "RecIndicator",
                    "TripCount",
                    "AccelPedalAngle",
                    "TRCControl",
                    "TirePressureFL_TypeB",
                    "BrakePedalPressure",
                    "DoorOpenRL",
                    "RearWiperOpsState",
                    "WindowPositionRR",
                    "TPMonitoringStateSP",
                    "DoorLockPositionD",
                    "Odo",
                    "HoodOpen",
                    "ATShiftPosition",
                    "FuelGauge_TypeB",
                    "DoorOpenP",
                    "WheelSpeedFR",
                    "WheelSpeedRL",
                    "TirePressureRR_TypeB",
                    "BrakeTorque",
                    "TirePressureFR_TypeB",
                    "TirePressureRL_TypeB",
                    "TPMonitoringStateFR"
                ]
            ]
        }
    ]
}

export const linkCdadMapFilterAttributes = {
    "mapView_data": [
        {
            "zip_code": "48009",
            "city_name": "Birmingham",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.54421,
            "longitude": -83.21766,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.21714782714844 42.54515838623047, -83.21714782714844 42.54508972167969), (-83.21714782714844 42.54508972167969, -83.2171401977539 42.54497146606445), (-83.2171401977539 42.54497146606445, -83.21713256835938 42.544795989990234), (-83.21713256835938 42.544795989990234, -83.21713256835938 42.544708251953125), (-83.21713256835938 42.544708251953125, -83.21712493896484 42.54460906982422), (-83.21712493896484 42.54460906982422, -83.21712493896484 42.54450988769531), (-83.21712493896484 42.54450988769531, -83.21711730957031 42.5444221496582))",
            "surface": "asphalt",
            "maxspeed": "25 mph",
            "name": "South Bates Street"
        },
        {
            "zip_code": "48084",
            "city_name": "Troy",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.56064,
            "longitude": -83.17572,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.17656707763672 42.561405181884766, -83.17646026611328 42.56140899658203), (-83.17646026611328 42.56140899658203, -83.17532348632812 42.56144332885742), (-83.17532348632812 42.56144332885742, -83.17524719238281 42.56144714355469), (-83.17524719238281 42.56144714355469, -83.17504119873047 42.56145477294922))",
            "surface": "concrete",
            "maxspeed": "45 mph",
            "name": "West Big Beaver Road"
        },
        {
            "zip_code": "48301",
            "city_name": "Bloomfield Hills",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.54444,
            "longitude": -83.28284,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.28277587890625 42.544864654541016, -83.2828598022461 42.544864654541016), (-83.2828598022461 42.544864654541016, -83.28298950195312 42.54486083984375))",
            "surface": "asphalt",
            "maxspeed": "45 mph",
            "name": "West Maple Road"
        },
        {
            "zip_code": "48304",
            "city_name": "Bloomfield Hills",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.58765,
            "longitude": -83.23463,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.23567962646484 42.58724594116211, -83.235595703125 42.587345123291016))",
            "surface": "asphalt",
            "maxspeed": "40 mph",
            "name": "East Long Lake Road"
        },
        {
            "zip_code": "48322",
            "city_name": "West Bloomfield",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.54215,
            "longitude": -83.38137,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.38037109375 42.54310607910156, -83.38037872314453 42.54314041137695), (-83.38037872314453 42.54314041137695, -83.38041687011719 42.543338775634766), (-83.38041687011719 42.543338775634766, -83.38042449951172 42.54359817504883), (-83.38042449951172 42.54359817504883, -83.38041687011719 42.5439453125), (-83.38041687011719 42.5439453125, -83.38043212890625 42.54426193237305), (-83.38043212890625 42.54426193237305, -83.38045501708984 42.54469299316406), (-83.38045501708984 42.54469299316406, -83.38046264648438 42.544898986816406), (-83.38046264648438 42.544898986816406, -83.38050842285156 42.54566955566406), (-83.38050842285156 42.54566955566406, -83.38053894042969 42.5467529296875), (-83.38053894042969 42.5467529296875, -83.38053894042969 42.54677200317383), (-83.38053894042969 42.54677200317383, -83.38053131103516 42.54713821411133), (-83.38053131103516 42.54713821411133, -83.38052368164062 42.54733657836914), (-83.38052368164062 42.54733657836914, -83.3805160522461 42.547454833984375), (-83.3805160522461 42.547454833984375, -83.38048553466797 42.547821044921875), (-83.38048553466797 42.547821044921875, -83.38048553466797 42.5478630065918), (-83.38048553466797 42.5478630065918, -83.38037872314453 42.548187255859375), (-83.38037872314453 42.548187255859375, -83.38036346435547 42.548240661621094), (-83.38036346435547 42.548240661621094, -83.3803482055664 42.548282623291016), (-83.3803482055664 42.548282623291016, -83.38030242919922 42.54838943481445), (-83.38030242919922 42.54838943481445, -83.38021087646484 42.5485954284668), (-83.38021087646484 42.5485954284668, -83.37998962402344 42.5489387512207), (-83.37998962402344 42.5489387512207, -83.37966918945312 42.549278259277344), (-83.37966918945312 42.549278259277344, -83.37956237792969 42.549373626708984), (-83.37956237792969 42.549373626708984, -83.37899017333984 42.54986572265625), (-83.37899017333984 42.54986572265625, -83.37892150878906 42.5499267578125), (-83.37892150878906 42.5499267578125, -83.37857055664062 42.550235748291016), (-83.37857055664062 42.550235748291016, -83.37838745117188 42.55039596557617), (-83.37838745117188 42.55039596557617, -83.3782958984375 42.550472259521484), (-83.3782958984375 42.550472259521484, -83.37805938720703 42.55066680908203), (-83.37805938720703 42.55066680908203, -83.37733459472656 42.55133056640625), (-83.37733459472656 42.55133056640625, -83.37698364257812 42.5516471862793), (-83.37698364257812 42.5516471862793, -83.37689208984375 42.551734924316406), (-83.37689208984375 42.551734924316406, -83.37654876708984 42.55210494995117), (-83.37654876708984 42.55210494995117, -83.37631225585938 42.552406311035156), (-83.37631225585938 42.552406311035156, -83.37620544433594 42.552555084228516), (-83.37620544433594 42.552555084228516, -83.37608337402344 42.5527458190918), (-83.37608337402344 42.5527458190918, -83.37593841552734 42.553016662597656), (-83.37593841552734 42.553016662597656, -83.3758544921875 42.553287506103516), (-83.3758544921875 42.553287506103516, -83.37581634521484 42.55366516113281), (-83.37581634521484 42.55366516113281, -83.37581634521484 42.55376052856445), (-83.37581634521484 42.55376052856445, -83.37581634521484 42.55401611328125), (-83.37581634521484 42.55401611328125, -83.3758544921875 42.55473327636719), (-83.3758544921875 42.55473327636719, -83.37591552734375 42.55568313598633), (-83.37591552734375 42.55568313598633, -83.37598419189453 42.55710220336914))",
            "surface": "asphalt",
            "maxspeed": "35 mph",
            "name": "Farmington Road"
        },
        {
            "zip_code": "48326",
            "city_name": "Auburn Hills",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.67577,
            "longitude": -83.25332,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.25416564941406 42.671661376953125, -83.25406646728516 42.671756744384766), (-83.25406646728516 42.671756744384766, -83.2540054321289 42.67181396484375), (-83.2540054321289 42.67181396484375, -83.25385284423828 42.67198181152344), (-83.25385284423828 42.67198181152344, -83.25366973876953 42.67219543457031), (-83.25366973876953 42.67219543457031, -83.25360107421875 42.67227554321289), (-83.25360107421875 42.67227554321289, -83.25353240966797 42.672359466552734), (-83.25353240966797 42.672359466552734, -83.25341796875 42.672515869140625), (-83.25341796875 42.672515869140625, -83.25331115722656 42.67267990112305), (-83.25331115722656 42.67267990112305, -83.25320434570312 42.67284393310547), (-83.25320434570312 42.67284393310547, -83.25312805175781 42.67296600341797), (-83.25312805175781 42.67296600341797, -83.25305938720703 42.673091888427734), (-83.25305938720703 42.673091888427734, -83.25294494628906 42.67332077026367), (-83.25294494628906 42.67332077026367, -83.25289154052734 42.67344284057617), (-83.25289154052734 42.67344284057617, -83.25279235839844 42.67368698120117), (-83.25279235839844 42.67368698120117, -83.25275421142578 42.67378616333008), (-83.25275421142578 42.67378616333008, -83.2527084350586 42.673919677734375), (-83.2527084350586 42.673919677734375, -83.25267028808594 42.6740608215332), (-83.25267028808594 42.6740608215332, -83.25263214111328 42.6741943359375), (-83.25263214111328 42.6741943359375, -83.25260162353516 42.6743278503418), (-83.25260162353516 42.6743278503418, -83.25257110595703 42.674503326416016), (-83.25257110595703 42.674503326416016, -83.25247192382812 42.675010681152344))",
            "surface": "asphalt",
            "maxspeed": "50 mph",
            "name": "North Perry Street"
        },
        {
            "zip_code": "48442",
            "city_name": "Holly",
            "state_code": "MI",
            "state_name": "Michigan",
            "county_code": "26125",
            "county_name": "Oakland",
            "latitude": 42.79164,
            "longitude": -83.60347,
            "vins": [
                "TESTVIN12345678901"
            ],
            "geometry": "MULTILINESTRING ((-83.60270690917969 42.792449951171875, -83.60163116455078 42.79247283935547), (-83.60163116455078 42.79247283935547, -83.60015869140625 42.792510986328125))",
            "surface": "asphalt",
            "maxspeed": "55 mph",
            "name": "East Holly Road"
        }
    ]
}


export const cDadUnNestedData ={

    "data": [

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165346329",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:52:44",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5807943",

            "longitude": "-83.2896332",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "0.1",

            "AccelLR": "-0.3",

            "Odo": "7269.41",

            "Speed": "61.78",

            "TripCount": "566.0",

            "WheelSpeedFL": "63.73",

            "WheelSpeedFR": "63.33",

            "row_num": "361"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165346329",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:53:04",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5810938",

            "longitude": "-83.2856923",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "-0.3",

            "AccelLR": "0.0",

            "Odo": "7269.41",

            "Speed": "63.68",

            "TripCount": "566.0",

            "WheelSpeedFL": "65.38",

            "WheelSpeedFR": "65.24",

            "row_num": "381"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165346329",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:53:24",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5812131",

            "longitude": "-83.2822222",

            "timeZoneOffset": "-5",

            "116_EACCP": "22.0",

            "381_I_REC": "0.0",

            "AccelFB": "1.0",

            "AccelLR": "0.1",

            "Odo": "7269.41",

            "Speed": "23.37",

            "TripCount": "566.0",

            "WheelSpeedFL": "24.17",

            "WheelSpeedFR": "24.12",

            "row_num": "401"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165446673",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:53:44",

            "pdop": "7",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5812326",

            "longitude": "-83.2814952",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "0.5",

            "AccelLR": "0.0",

            "Odo": "7269.41",

            "Speed": "0.0",

            "TripCount": "566.0",

            "WheelSpeedFL": "1.13",

            "WheelSpeedFR": "1.14",

            "row_num": "421"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165446673",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:54:04",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5796832",

            "longitude": "-83.2809939",

            "timeZoneOffset": "-5",

            "116_EACCP": "23.5",

            "381_I_REC": "0.0",

            "AccelFB": "-0.7",

            "AccelLR": "4.7",

            "Odo": "7269.41",

            "Speed": "22.3",

            "TripCount": "566.0",

            "WheelSpeedFL": "21.91",

            "WheelSpeedFR": "25.18",

            "row_num": "441"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165446673",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:54:24",

            "pdop": "7",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5811263",

            "longitude": "-83.2807964",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "-1.0",

            "AccelLR": "-0.1",

            "Odo": "7269.41",

            "Speed": "4.46",

            "TripCount": "566.0",

            "WheelSpeedFL": "4.9",

            "WheelSpeedFR": "4.52",

            "row_num": "461"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165546450",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:54:44",

            "pdop": "8",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5824414",

            "longitude": "-83.2808247",

            "timeZoneOffset": "-5",

            "116_EACCP": "22.0",

            "381_I_REC": "0.0",

            "AccelFB": "0.3",

            "AccelLR": "0.3",

            "Odo": "7269.41",

            "Speed": "93.28",

            "TripCount": "566.0",

            "WheelSpeedFL": "95.53",

            "WheelSpeedFR": "95.71",

            "row_num": "481"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165546450",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:55:00",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5862109",

            "longitude": "-83.2810829",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": null,

            "AccelFB": "0.0",

            "AccelLR": "0.4",

            "Odo": "7271.02",

            "Speed": "91.42",

            "TripCount": "566.0",

            "WheelSpeedFL": "93.64",

            "WheelSpeedFR": "93.66",

            "row_num": "497"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165546450",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:55:04",

            "pdop": "6",

            "hdop": "4",

            "vdop": "6",

            "latitude": "42.5871398",

            "longitude": "-83.2811545",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "0.0",

            "AccelLR": "0.1",

            "Odo": "7271.02",

            "Speed": "90.22",

            "TripCount": "566.0",

            "WheelSpeedFL": "92.55",

            "WheelSpeedFR": "92.4",

            "row_num": "501"

        },

        {

            "vin": "TESTVIN12345678901",

            "modelYear": "2024",

            "requestDateTime": "20241101165546450",

            "DispatchModelType": "TZNH47L-PRVSZA",

            "vehicleName": "TACOMA",

            "gpsDateTime": "2024-11-01 16:55:24",

            "pdop": "6",

            "hdop": "3",

            "vdop": "5",

            "latitude": "42.5917817",

            "longitude": "-83.2813563",

            "timeZoneOffset": "-5",

            "116_EACCP": "0.0",

            "381_I_REC": "0.0",

            "AccelFB": "0.0",

            "AccelLR": "-0.2",

            "Odo": "7271.02",

            "Speed": "90.74",

            "TripCount": "566.0",

            "WheelSpeedFL": "93.1",

            "WheelSpeedFR": "93.4",

            "row_num": "521"

        }

    ],

    "total": 191,

    "unnested_signals": [

        "116_EACCP",

        "381_I_REC",

        "Speed",

        "WheelSpeedFL",

        "WheelSpeedFR",

        "AccelFB",

        "AccelLR",

        "Odo"

    ],

    "Present_Signals": [

        "WheelSpeedFL",

        "Speed",

        "TripCount",

        "Odo",

        "WheelSpeedFR",

        "AccelFB",

        "AccelLR",

        "381_I_REC",

        "116_EACCP"

    ],

    "Missing_Signals": []

}
 
export const cDadDataVisualizationMapData  = [
    {
        "zip_code": "48009",
        "city_name": "Birmingham",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.54421,
        "longitude": -83.21766,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.21714782714844 42.54515838623047, -83.21714782714844 42.54508972167969), (-83.21714782714844 42.54508972167969, -83.2171401977539 42.54497146606445), (-83.2171401977539 42.54497146606445, -83.21713256835938 42.544795989990234), (-83.21713256835938 42.544795989990234, -83.21713256835938 42.544708251953125), (-83.21713256835938 42.544708251953125, -83.21712493896484 42.54460906982422), (-83.21712493896484 42.54460906982422, -83.21712493896484 42.54450988769531), (-83.21712493896484 42.54450988769531, -83.21711730957031 42.5444221496582))",
        "surface": "asphalt",
        "maxspeed": "25 mph",
        "name": "South Bates Street"
    },
    {
        "zip_code": "48084",
        "city_name": "Troy",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.56064,
        "longitude": -83.17572,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.17656707763672 42.561405181884766, -83.17646026611328 42.56140899658203), (-83.17646026611328 42.56140899658203, -83.17532348632812 42.56144332885742), (-83.17532348632812 42.56144332885742, -83.17524719238281 42.56144714355469), (-83.17524719238281 42.56144714355469, -83.17504119873047 42.56145477294922))",
        "surface": "concrete",
        "maxspeed": "45 mph",
        "name": "West Big Beaver Road"
    },
    {
        "zip_code": "48301",
        "city_name": "Bloomfield Hills",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.54444,
        "longitude": -83.28284,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.28277587890625 42.544864654541016, -83.2828598022461 42.544864654541016), (-83.2828598022461 42.544864654541016, -83.28298950195312 42.54486083984375))",
        "surface": "asphalt",
        "maxspeed": "45 mph",
        "name": "West Maple Road"
    },
    {
        "zip_code": "48304",
        "city_name": "Bloomfield Hills",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.58765,
        "longitude": -83.23463,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.23567962646484 42.58724594116211, -83.235595703125 42.587345123291016))",
        "surface": "asphalt",
        "maxspeed": "40 mph",
        "name": "East Long Lake Road"
    },
    {
        "zip_code": "48322",
        "city_name": "West Bloomfield",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.54215,
        "longitude": -83.38137,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.38037109375 42.54310607910156, -83.38037872314453 42.54314041137695), (-83.38037872314453 42.54314041137695, -83.38041687011719 42.543338775634766), (-83.38041687011719 42.543338775634766, -83.38042449951172 42.54359817504883), (-83.38042449951172 42.54359817504883, -83.38041687011719 42.5439453125), (-83.38041687011719 42.5439453125, -83.38043212890625 42.54426193237305), (-83.38043212890625 42.54426193237305, -83.38045501708984 42.54469299316406), (-83.38045501708984 42.54469299316406, -83.38046264648438 42.544898986816406), (-83.38046264648438 42.544898986816406, -83.38050842285156 42.54566955566406), (-83.38050842285156 42.54566955566406, -83.38053894042969 42.5467529296875), (-83.38053894042969 42.5467529296875, -83.38053894042969 42.54677200317383), (-83.38053894042969 42.54677200317383, -83.38053131103516 42.54713821411133), (-83.38053131103516 42.54713821411133, -83.38052368164062 42.54733657836914), (-83.38052368164062 42.54733657836914, -83.3805160522461 42.547454833984375), (-83.3805160522461 42.547454833984375, -83.38048553466797 42.547821044921875), (-83.38048553466797 42.547821044921875, -83.38048553466797 42.5478630065918), (-83.38048553466797 42.5478630065918, -83.38037872314453 42.548187255859375), (-83.38037872314453 42.548187255859375, -83.38036346435547 42.548240661621094), (-83.38036346435547 42.548240661621094, -83.3803482055664 42.548282623291016), (-83.3803482055664 42.548282623291016, -83.38030242919922 42.54838943481445), (-83.38030242919922 42.54838943481445, -83.38021087646484 42.5485954284668), (-83.38021087646484 42.5485954284668, -83.37998962402344 42.5489387512207), (-83.37998962402344 42.5489387512207, -83.37966918945312 42.549278259277344), (-83.37966918945312 42.549278259277344, -83.37956237792969 42.549373626708984), (-83.37956237792969 42.549373626708984, -83.37899017333984 42.54986572265625), (-83.37899017333984 42.54986572265625, -83.37892150878906 42.5499267578125), (-83.37892150878906 42.5499267578125, -83.37857055664062 42.550235748291016), (-83.37857055664062 42.550235748291016, -83.37838745117188 42.55039596557617), (-83.37838745117188 42.55039596557617, -83.3782958984375 42.550472259521484), (-83.3782958984375 42.550472259521484, -83.37805938720703 42.55066680908203), (-83.37805938720703 42.55066680908203, -83.37733459472656 42.55133056640625), (-83.37733459472656 42.55133056640625, -83.37698364257812 42.5516471862793), (-83.37698364257812 42.5516471862793, -83.37689208984375 42.551734924316406), (-83.37689208984375 42.551734924316406, -83.37654876708984 42.55210494995117), (-83.37654876708984 42.55210494995117, -83.37631225585938 42.552406311035156), (-83.37631225585938 42.552406311035156, -83.37620544433594 42.552555084228516), (-83.37620544433594 42.552555084228516, -83.37608337402344 42.5527458190918), (-83.37608337402344 42.5527458190918, -83.37593841552734 42.553016662597656), (-83.37593841552734 42.553016662597656, -83.3758544921875 42.553287506103516), (-83.3758544921875 42.553287506103516, -83.37581634521484 42.55366516113281), (-83.37581634521484 42.55366516113281, -83.37581634521484 42.55376052856445), (-83.37581634521484 42.55376052856445, -83.37581634521484 42.55401611328125), (-83.37581634521484 42.55401611328125, -83.3758544921875 42.55473327636719), (-83.3758544921875 42.55473327636719, -83.37591552734375 42.55568313598633), (-83.37591552734375 42.55568313598633, -83.37598419189453 42.55710220336914))",
        "surface": "asphalt",
        "maxspeed": "35 mph",
        "name": "Farmington Road"
    },
    {
        "zip_code": "48326",
        "city_name": "Auburn Hills",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.67577,
        "longitude": -83.25332,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.25416564941406 42.671661376953125, -83.25406646728516 42.671756744384766), (-83.25406646728516 42.671756744384766, -83.2540054321289 42.67181396484375), (-83.2540054321289 42.67181396484375, -83.25385284423828 42.67198181152344), (-83.25385284423828 42.67198181152344, -83.25366973876953 42.67219543457031), (-83.25366973876953 42.67219543457031, -83.25360107421875 42.67227554321289), (-83.25360107421875 42.67227554321289, -83.25353240966797 42.672359466552734), (-83.25353240966797 42.672359466552734, -83.25341796875 42.672515869140625), (-83.25341796875 42.672515869140625, -83.25331115722656 42.67267990112305), (-83.25331115722656 42.67267990112305, -83.25320434570312 42.67284393310547), (-83.25320434570312 42.67284393310547, -83.25312805175781 42.67296600341797), (-83.25312805175781 42.67296600341797, -83.25305938720703 42.673091888427734), (-83.25305938720703 42.673091888427734, -83.25294494628906 42.67332077026367), (-83.25294494628906 42.67332077026367, -83.25289154052734 42.67344284057617), (-83.25289154052734 42.67344284057617, -83.25279235839844 42.67368698120117), (-83.25279235839844 42.67368698120117, -83.25275421142578 42.67378616333008), (-83.25275421142578 42.67378616333008, -83.2527084350586 42.673919677734375), (-83.2527084350586 42.673919677734375, -83.25267028808594 42.6740608215332), (-83.25267028808594 42.6740608215332, -83.25263214111328 42.6741943359375), (-83.25263214111328 42.6741943359375, -83.25260162353516 42.6743278503418), (-83.25260162353516 42.6743278503418, -83.25257110595703 42.674503326416016), (-83.25257110595703 42.674503326416016, -83.25247192382812 42.675010681152344))",
        "surface": "asphalt",
        "maxspeed": "50 mph",
        "name": "North Perry Street"
    },
    {
        "zip_code": "48442",
        "city_name": "Holly",
        "state_code": "MI",
        "state_name": "Michigan",
        "county_code": "26125",
        "county_name": "Oakland",
        "latitude": 42.79164,
        "longitude": -83.60347,
        "vins": [
            "TESTVIN12345678901"
        ],
        "geometry": "MULTILINESTRING ((-83.60270690917969 42.792449951171875, -83.60163116455078 42.79247283935547), (-83.60163116455078 42.79247283935547, -83.60015869140625 42.792510986328125))",
        "surface": "asphalt",
        "maxspeed": "55 mph",
        "name": "East Holly Road"
    }
]

export const cDadFaultData = {
    "data": {
        "116_EACCP": [
            {
                "Count": "128",
                "min": "0.0",
                "max": "7.0"
            },
            {
                "Count": "11",
                "min": "7.0",
                "max": "14.0"
            },
            {
                "Count": "11",
                "min": "14.0",
                "max": "21.0"
            },
            {
                "Count": "24",
                "min": "21.0",
                "max": "28.0"
            },
            {
                "Count": "16",
                "min": "28.0",
                "max": "35.0"
            },
            {
                "Count": "4",
                "min": "35.0",
                "max": "40.0"
            }
        ],
        "381_I_REC": [
            {
                "Count": "158",
                "min": "0",
                "max": "0"
            }
        ],
        "AccelFB": [
            {
                "Count": "2",
                "min": "-3.3",
                "max": "-2.3"
            },
            {
                "Count": "5",
                "min": "-2.3",
                "max": "-1.2999999999999998"
            },
            {
                "Count": "81",
                "min": "-1.2999999999999998",
                "max": "-0.2999999999999998"
            },
            {
                "Count": "24",
                "min": "-0.2999999999999998",
                "max": "0.7000000000000002"
            },
            {
                "Count": "108",
                "min": "0.7000000000000002",
                "max": "1.7000000000000002"
            },
            {
                "Count": "15",
                "min": "1.7000000000000002",
                "max": "2.7"
            },
            {
                "Count": "6",
                "min": "2.7",
                "max": "3.3"
            }
        ],
        "AccelLR": [
            {
                "Count": "5",
                "min": "-2.8",
                "max": "-1.7999999999999998"
            },
            {
                "Count": "59",
                "min": "-1.7999999999999998",
                "max": "-0.7999999999999998"
            },
            {
                "Count": "29",
                "min": "-0.7999999999999998",
                "max": "0.20000000000000018"
            },
            {
                "Count": "144",
                "min": "0.20000000000000018",
                "max": "1.2000000000000002"
            },
            {
                "Count": "11",
                "min": "1.2000000000000002",
                "max": "2.2"
            },
            {
                "Count": "1",
                "min": "2.2",
                "max": "3.2"
            },
            {
                "Count": "1",
                "min": "3.2",
                "max": "4.2"
            },
            {
                "Count": "0",
                "min": "4.2",
                "max": "4.8"
            }
        ],
        "Odo": [
            {
                "Count": "53",
                "min": "7269.41",
                "max": "7278.41"
            },
            {
                "Count": "23",
                "min": "7278.41",
                "max": "7287.41"
            },
            {
                "Count": "21",
                "min": "7287.41",
                "max": "7296.41"
            },
            {
                "Count": "27",
                "min": "7296.41",
                "max": "7305.41"
            },
            {
                "Count": "24",
                "min": "7305.41",
                "max": "7314.41"
            },
            {
                "Count": "30",
                "min": "7314.41",
                "max": "7323.41"
            },
            {
                "Count": "0",
                "min": "7323.41",
                "max": "7324.12"
            }
        ],
        "Speed": [
            {
                "Count": "28",
                "min": "0.0",
                "max": "10.0"
            },
            {
                "Count": "4",
                "min": "10.0",
                "max": "20.0"
            },
            {
                "Count": "11",
                "min": "20.0",
                "max": "30.0"
            },
            {
                "Count": "12",
                "min": "30.0",
                "max": "40.0"
            },
            {
                "Count": "11",
                "min": "40.0",
                "max": "50.0"
            },
            {
                "Count": "13",
                "min": "50.0",
                "max": "60.0"
            },
            {
                "Count": "13",
                "min": "60.0",
                "max": "70.0"
            },
            {
                "Count": "9",
                "min": "70.0",
                "max": "80.0"
            },
            {
                "Count": "7",
                "min": "80.0",
                "max": "90.0"
            },
            {
                "Count": "34",
                "min": "90.0",
                "max": "100.0"
            },
            {
                "Count": "15",
                "min": "100.0",
                "max": "110.0"
            },
            {
                "Count": "12",
                "min": "110.0",
                "max": "120.0"
            },
            {
                "Count": "19",
                "min": "120.0",
                "max": "130.0"
            },
            {
                "Count": "2",
                "min": "130.0",
                "max": "135.41"
            }
        ],
        "WheelSpeedFL": [
            {
                "Count": "28",
                "min": "0.0",
                "max": "11.0"
            },
            {
                "Count": "7",
                "min": "11.0",
                "max": "22.0"
            },
            {
                "Count": "8",
                "min": "22.0",
                "max": "33.0"
            },
            {
                "Count": "15",
                "min": "33.0",
                "max": "44.0"
            },
            {
                "Count": "10",
                "min": "44.0",
                "max": "55.0"
            },
            {
                "Count": "21",
                "min": "55.0",
                "max": "66.0"
            },
            {
                "Count": "8",
                "min": "66.0",
                "max": "77.0"
            },
            {
                "Count": "6",
                "min": "77.0",
                "max": "88.0"
            },
            {
                "Count": "24",
                "min": "88.0",
                "max": "99.0"
            },
            {
                "Count": "24",
                "min": "99.0",
                "max": "110.0"
            },
            {
                "Count": "15",
                "min": "110.0",
                "max": "121.0"
            },
            {
                "Count": "21",
                "min": "121.0",
                "max": "132.0"
            },
            {
                "Count": "3",
                "min": "132.0",
                "max": "139.03"
            }
        ],
        "WheelSpeedFR": [
            {
                "Count": "28",
                "min": "0.0",
                "max": "11.0"
            },
            {
                "Count": "4",
                "min": "11.0",
                "max": "22.0"
            },
            {
                "Count": "11",
                "min": "22.0",
                "max": "33.0"
            },
            {
                "Count": "15",
                "min": "33.0",
                "max": "44.0"
            },
            {
                "Count": "12",
                "min": "44.0",
                "max": "55.0"
            },
            {
                "Count": "19",
                "min": "55.0",
                "max": "66.0"
            },
            {
                "Count": "8",
                "min": "66.0",
                "max": "77.0"
            },
            {
                "Count": "6",
                "min": "77.0",
                "max": "88.0"
            },
            {
                "Count": "24",
                "min": "88.0",
                "max": "99.0"
            },
            {
                "Count": "25",
                "min": "99.0",
                "max": "110.0"
            },
            {
                "Count": "15",
                "min": "110.0",
                "max": "121.0"
            },
            {
                "Count": "20",
                "min": "121.0",
                "max": "132.0"
            },
            {
                "Count": "2",
                "min": "132.0",
                "max": "138.89"
            }
        ]
    },
    "total_count": 191
}

export const timeSeriesdata = {
    "TESTVIN12345678901": [
        {
            "116_EACCP": 0.0,
            "Speed": 61.78,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:52:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 63.68,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:53:04"
        },
        {
            "116_EACCP": 22.0,
            "Speed": 23.37,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:53:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:53:44"
        },
        {
            "116_EACCP": 23.5,
            "Speed": 22.3,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:54:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 4.46,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:54:24"
        },
        {
            "116_EACCP": 22.0,
            "Speed": 93.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:54:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 91.42,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:55:00"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 90.22,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:55:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 90.74,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:55:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 63.75,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:55:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 76.13,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:56:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 67.48,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:56:09"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 41.72,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:56:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:56:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:57:04"
        },
        {
            "116_EACCP": 21.5,
            "Speed": 39.9,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:57:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 60.65,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:57:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 54.53,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:58:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 46.98,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:58:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 5.15,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:58:44"
        },
        {
            "116_EACCP": 26.5,
            "Speed": 27.24,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:59:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 61.54,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:59:16"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 64.09,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:59:24"
        },
        {
            "116_EACCP": 23.5,
            "Speed": 56.11,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 16:59:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:00:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:00:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 16.76,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:00:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 51.8,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:01:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:01:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:01:44"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:02:04"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 25.5,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:02:24"
        },
        {
            "116_EACCP": 8.5,
            "Speed": 32.23,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:02:44"
        },
        {
            "116_EACCP": 14.5,
            "Speed": 34.96,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:03:04"
        },
        {
            "116_EACCP": 12.5,
            "Speed": 36.6,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 17:03:24"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 4.05,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:42:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 35.32,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:42:38"
        },
        {
            "116_EACCP": 21.0,
            "Speed": 29.85,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:42:58"
        },
        {
            "116_EACCP": 10.5,
            "Speed": 40.54,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:43:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 34.96,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:43:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:43:58"
        },
        {
            "116_EACCP": 31.0,
            "Speed": 6.7,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:44:18"
        },
        {
            "116_EACCP": 15.0,
            "Speed": 73.7,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:44:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:44:58"
        },
        {
            "116_EACCP": 19.5,
            "Speed": 78.25,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:45:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 56.49,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:45:38"
        },
        {
            "116_EACCP": 23.0,
            "Speed": 25.65,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:45:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:46:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:46:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 45.7,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:46:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 55.73,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:47:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 55.17,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:47:38"
        },
        {
            "116_EACCP": 22.5,
            "Speed": 63.44,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:47:55"
        },
        {
            "116_EACCP": 38.0,
            "Speed": 73.8,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:47:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 77.17,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:48:18"
        },
        {
            "116_EACCP": 22.5,
            "Speed": 72.18,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:48:38"
        },
        {
            "116_EACCP": 2.5,
            "Speed": 53.65,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:48:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 36.06,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:49:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:49:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:49:58"
        },
        {
            "116_EACCP": 30.5,
            "Speed": 42.46,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:50:17"
        },
        {
            "116_EACCP": 30.5,
            "Speed": 49.49,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:50:18"
        },
        {
            "116_EACCP": 36.0,
            "Speed": 81.55,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:50:38"
        },
        {
            "116_EACCP": 19.0,
            "Speed": 124.68,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:50:58"
        },
        {
            "116_EACCP": 29.0,
            "Speed": 126.62,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:51:17"
        },
        {
            "116_EACCP": 29.0,
            "Speed": 127.06,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:51:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 115.5,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:51:38"
        },
        {
            "116_EACCP": 40.0,
            "Speed": 72.93,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:51:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 55.71,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:52:14"
        },
        {
            "116_EACCP": 31.0,
            "Speed": 54.1,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:52:18"
        },
        {
            "116_EACCP": 34.5,
            "Speed": 134.31,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:52:38"
        },
        {
            "116_EACCP": 23.0,
            "Speed": 135.41,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:52:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 132.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:53:06"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 125.13,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:53:18"
        },
        {
            "116_EACCP": 30.5,
            "Speed": 135.18,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:53:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 125.37,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:53:52"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 126.39,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:53:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 122.53,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:54:18"
        },
        {
            "116_EACCP": 8.0,
            "Speed": 108.73,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:54:38"
        },
        {
            "116_EACCP": 10.0,
            "Speed": 106.92,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:54:39"
        },
        {
            "116_EACCP": 33.0,
            "Speed": 125.69,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:54:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 117.96,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:55:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 112.63,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:55:26"
        },
        {
            "116_EACCP": 23.0,
            "Speed": 107.67,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:55:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 125.01,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:55:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 124.7,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:56:15"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 116.46,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:56:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 119.21,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:56:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 123.68,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:56:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 121.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:57:06"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 89.16,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:57:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 92.07,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:57:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 105.55,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:57:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 109.15,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:58:06"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 122.88,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:58:17"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 123.98,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:58:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 124.42,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:58:53"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 125.78,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:58:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 124.55,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:59:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 124.55,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:59:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 124.33,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:59:40"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 117.96,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 18:59:58"
        },
        {
            "116_EACCP": 25.0,
            "Speed": 116.97,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:00:17"
        },
        {
            "116_EACCP": 27.5,
            "Speed": 110.08,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:00:29"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 107.07,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:00:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 95.7,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:00:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 54.11,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:01:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 59.84,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:01:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 60.23,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:01:43"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 56.11,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:01:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 46.44,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:02:17"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 37.51,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:02:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 33.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:02:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 46.61,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:03:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 65.52,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:03:37"
        },
        {
            "116_EACCP": 12.5,
            "Speed": 71.17,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:03:46"
        },
        {
            "116_EACCP": 22.0,
            "Speed": 89.03,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:03:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:04:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 104.99,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:04:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 106.39,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:04:46"
        },
        {
            "116_EACCP": 13.5,
            "Speed": 103.13,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:04:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 110.02,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:05:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 106.19,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:05:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 109.22,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:05:41"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 110.15,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:05:58"
        },
        {
            "116_EACCP": 28.0,
            "Speed": 103.74,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:06:18"
        },
        {
            "116_EACCP": 14.5,
            "Speed": 103.25,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:06:37"
        },
        {
            "116_EACCP": 14.5,
            "Speed": 102.2,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:06:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 11.23,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:06:57"
        },
        {
            "116_EACCP": 18.5,
            "Speed": 94.25,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:07:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 94.58,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:07:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 91.67,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:07:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 90.99,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:08:00"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 91.2,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:08:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 90.92,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:08:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 62.47,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:08:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:09:18"
        },
        {
            "116_EACCP": 5.0,
            "Speed": 66.41,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:09:30"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 39.75,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:09:37"
        },
        {
            "116_EACCP": 18.0,
            "Speed": 62.62,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:09:58"
        },
        {
            "116_EACCP": 31.0,
            "Speed": 92.33,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:10:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 85.08,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:10:37"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 87.65,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:10:53"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 79.76,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:10:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 89.62,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:11:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 91.34,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:11:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 95.8,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:11:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 96.78,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:11:59"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 97.62,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:12:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 96.94,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:12:38"
        },
        {
            "116_EACCP": 29.0,
            "Speed": 111.76,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:12:58"
        },
        {
            "116_EACCP": 32.0,
            "Speed": 110.86,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:13:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.43,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:13:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.85,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:13:53"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.3,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:13:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.45,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:14:17"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.31,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:14:38"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 99.82,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:14:52"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 100.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:14:57"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 97.28,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:15:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 98.54,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:15:38"
        },
        {
            "116_EACCP": 25.0,
            "Speed": 93.64,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:15:51"
        },
        {
            "116_EACCP": 26.5,
            "Speed": 91.79,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:15:58"
        },
        {
            "116_EACCP": 25.0,
            "Speed": 99.18,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:16:18"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 40.19,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:16:37"
        },
        {
            "116_EACCP": 10.0,
            "Speed": 10.61,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:16:58"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:25:25"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 4.81,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:25:45"
        },
        {
            "116_EACCP": 13.0,
            "Speed": 6.22,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:26:05"
        },
        {
            "116_EACCP": 25.0,
            "Speed": 93.81,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:26:22"
        },
        {
            "116_EACCP": 26.5,
            "Speed": 94.2,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:26:25"
        },
        {
            "116_EACCP": 21.5,
            "Speed": 99.47,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:26:45"
        },
        {
            "116_EACCP": 26.5,
            "Speed": 24.52,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:27:05"
        },
        {
            "116_EACCP": 21.5,
            "Speed": 22.92,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:27:25"
        },
        {
            "116_EACCP": 3.0,
            "Speed": 6.08,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:27:45"
        },
        {
            "116_EACCP": 12.0,
            "Speed": 45.25,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:28:05"
        },
        {
            "116_EACCP": 17.5,
            "Speed": 20.79,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:28:25"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 36.45,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:28:39"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 24.62,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:28:45"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 7.36,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:29:05"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:29:25"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:29:45"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:30:05"
        },
        {
            "116_EACCP": 19.5,
            "Speed": 0.0,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:30:25"
        },
        {
            "116_EACCP": 33.0,
            "Speed": 21.29,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:30:45"
        },
        {
            "116_EACCP": 35.0,
            "Speed": 33.84,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:31:05"
        },
        {
            "116_EACCP": 2.0,
            "Speed": 86.53,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:31:25"
        },
        {
            "116_EACCP": 34.0,
            "Speed": 46.34,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:31:45"
        },
        {
            "116_EACCP": 0.0,
            "Speed": 13.39,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:32:05"
        },
        {
            "116_EACCP": 13.5,
            "Speed": 50.73,
            "vin": "TESTVIN12345678901",
            "gpsDateTime": "2024-11-01 19:32:25"
        }
    ]
}

export const histoGramData = [
    [
        12.65,
        7.56,
        4.85,
        12.65,
        7.56,
        4.85
    ],
    [
        30.78,
        83.72,
        39.01,
        30.78,
        83.72,
        39.01
    ]
]

export const barChartData = {
    "116_EACCP": {
        "TESTVIN12345678901": [
            {
                "value": 0.0,
                "count": 124.0
            },
            {
                "value": 2.0,
                "count": 1.0
            },
            {
                "value": 2.5,
                "count": 1.0
            },
            {
                "value": 3.0,
                "count": 1.0
            },
            {
                "value": 5.0,
                "count": 1.0
            },
            {
                "value": 8.0,
                "count": 1.0
            },
            {
                "value": 8.5,
                "count": 1.0
            },
            {
                "value": 10.0,
                "count": 2.0
            },
            {
                "value": 10.5,
                "count": 1.0
            },
            {
                "value": 12.0,
                "count": 1.0
            },
            {
                "value": 12.5,
                "count": 2.0
            },
            {
                "value": 13.0,
                "count": 1.0
            },
            {
                "value": 13.5,
                "count": 2.0
            },
            {
                "value": 14.5,
                "count": 3.0
            },
            {
                "value": 15.0,
                "count": 1.0
            },
            {
                "value": 17.5,
                "count": 1.0
            },
            {
                "value": 18.0,
                "count": 1.0
            },
            {
                "value": 18.5,
                "count": 1.0
            },
            {
                "value": 19.0,
                "count": 1.0
            },
            {
                "value": 19.5,
                "count": 2.0
            },
            {
                "value": 21.0,
                "count": 1.0
            },
            {
                "value": 21.5,
                "count": 3.0
            },
            {
                "value": 22.0,
                "count": 3.0
            },
            {
                "value": 22.5,
                "count": 2.0
            },
            {
                "value": 23.0,
                "count": 3.0
            },
            {
                "value": 23.5,
                "count": 2.0
            },
            {
                "value": 25.0,
                "count": 4.0
            },
            {
                "value": 26.5,
                "count": 4.0
            },
            {
                "value": 27.5,
                "count": 1.0
            },
            {
                "value": 28.0,
                "count": 1.0
            },
            {
                "value": 29.0,
                "count": 3.0
            },
            {
                "value": 30.5,
                "count": 3.0
            },
            {
                "value": 31.0,
                "count": 3.0
            },
            {
                "value": 32.0,
                "count": 1.0
            },
            {
                "value": 33.0,
                "count": 2.0
            },
            {
                "value": 34.0,
                "count": 1.0
            },
            {
                "value": 34.5,
                "count": 1.0
            },
            {
                "value": 35.0,
                "count": 1.0
            },
            {
                "value": 36.0,
                "count": 1.0
            },
            {
                "value": 38.0,
                "count": 1.0
            },
            {
                "value": 40.0,
                "count": 1.0
            }
        ]
    },
    "Speed": {
        "TESTVIN12345678901": [
            {
                "value": 0.0,
                "count": 20.0
            },
            {
                "value": 4.05,
                "count": 1.0
            },
            {
                "value": 4.46,
                "count": 1.0
            },
            {
                "value": 4.81,
                "count": 1.0
            },
            {
                "value": 5.15,
                "count": 1.0
            },
            {
                "value": 6.08,
                "count": 1.0
            },
            {
                "value": 6.22,
                "count": 1.0
            },
            {
                "value": 6.7,
                "count": 1.0
            },
            {
                "value": 7.36,
                "count": 1.0
            },
            {
                "value": 10.61,
                "count": 1.0
            },
            {
                "value": 11.23,
                "count": 1.0
            },
            {
                "value": 13.39,
                "count": 1.0
            },
            {
                "value": 16.76,
                "count": 1.0
            },
            {
                "value": 20.79,
                "count": 1.0
            },
            {
                "value": 21.29,
                "count": 1.0
            },
            {
                "value": 22.3,
                "count": 1.0
            },
            {
                "value": 22.92,
                "count": 1.0
            },
            {
                "value": 23.37,
                "count": 1.0
            },
            {
                "value": 24.52,
                "count": 1.0
            },
            {
                "value": 24.62,
                "count": 1.0
            },
            {
                "value": 25.5,
                "count": 1.0
            },
            {
                "value": 25.65,
                "count": 1.0
            },
            {
                "value": 27.24,
                "count": 1.0
            },
            {
                "value": 29.85,
                "count": 1.0
            },
            {
                "value": 32.23,
                "count": 1.0
            },
            {
                "value": 33.28,
                "count": 1.0
            },
            {
                "value": 33.84,
                "count": 1.0
            },
            {
                "value": 34.96,
                "count": 2.0
            },
            {
                "value": 35.32,
                "count": 1.0
            },
            {
                "value": 36.06,
                "count": 1.0
            },
            {
                "value": 36.45,
                "count": 1.0
            },
            {
                "value": 36.6,
                "count": 1.0
            },
            {
                "value": 37.51,
                "count": 1.0
            },
            {
                "value": 39.75,
                "count": 1.0
            },
            {
                "value": 39.9,
                "count": 1.0
            },
            {
                "value": 40.19,
                "count": 1.0
            },
            {
                "value": 40.54,
                "count": 1.0
            },
            {
                "value": 41.72,
                "count": 1.0
            },
            {
                "value": 42.46,
                "count": 1.0
            },
            {
                "value": 45.25,
                "count": 1.0
            },
            {
                "value": 45.7,
                "count": 1.0
            },
            {
                "value": 46.34,
                "count": 1.0
            },
            {
                "value": 46.44,
                "count": 1.0
            },
            {
                "value": 46.61,
                "count": 1.0
            },
            {
                "value": 46.98,
                "count": 1.0
            },
            {
                "value": 49.49,
                "count": 1.0
            },
            {
                "value": 50.73,
                "count": 1.0
            },
            {
                "value": 51.8,
                "count": 1.0
            },
            {
                "value": 53.65,
                "count": 1.0
            },
            {
                "value": 54.1,
                "count": 1.0
            },
            {
                "value": 54.11,
                "count": 1.0
            },
            {
                "value": 54.53,
                "count": 1.0
            },
            {
                "value": 55.17,
                "count": 1.0
            },
            {
                "value": 55.71,
                "count": 1.0
            },
            {
                "value": 55.73,
                "count": 1.0
            },
            {
                "value": 56.11,
                "count": 2.0
            },
            {
                "value": 56.49,
                "count": 1.0
            },
            {
                "value": 59.84,
                "count": 1.0
            },
            {
                "value": 60.23,
                "count": 1.0
            },
            {
                "value": 60.65,
                "count": 1.0
            },
            {
                "value": 61.54,
                "count": 1.0
            },
            {
                "value": 61.78,
                "count": 1.0
            },
            {
                "value": 62.47,
                "count": 1.0
            },
            {
                "value": 62.62,
                "count": 1.0
            },
            {
                "value": 63.44,
                "count": 1.0
            },
            {
                "value": 63.68,
                "count": 1.0
            },
            {
                "value": 63.75,
                "count": 1.0
            },
            {
                "value": 64.09,
                "count": 1.0
            },
            {
                "value": 65.52,
                "count": 1.0
            },
            {
                "value": 66.41,
                "count": 1.0
            },
            {
                "value": 67.48,
                "count": 1.0
            },
            {
                "value": 71.17,
                "count": 1.0
            },
            {
                "value": 72.18,
                "count": 1.0
            },
            {
                "value": 72.93,
                "count": 1.0
            },
            {
                "value": 73.7,
                "count": 1.0
            },
            {
                "value": 73.8,
                "count": 1.0
            },
            {
                "value": 76.13,
                "count": 1.0
            },
            {
                "value": 77.17,
                "count": 1.0
            },
            {
                "value": 78.25,
                "count": 1.0
            },
            {
                "value": 79.76,
                "count": 1.0
            },
            {
                "value": 81.55,
                "count": 1.0
            },
            {
                "value": 85.08,
                "count": 1.0
            },
            {
                "value": 86.53,
                "count": 1.0
            },
            {
                "value": 87.65,
                "count": 1.0
            },
            {
                "value": 89.03,
                "count": 1.0
            },
            {
                "value": 89.16,
                "count": 1.0
            },
            {
                "value": 89.62,
                "count": 1.0
            },
            {
                "value": 90.22,
                "count": 1.0
            },
            {
                "value": 90.74,
                "count": 1.0
            },
            {
                "value": 90.92,
                "count": 1.0
            },
            {
                "value": 90.99,
                "count": 1.0
            },
            {
                "value": 91.2,
                "count": 1.0
            },
            {
                "value": 91.34,
                "count": 1.0
            },
            {
                "value": 91.42,
                "count": 1.0
            },
            {
                "value": 91.67,
                "count": 1.0
            },
            {
                "value": 91.79,
                "count": 1.0
            },
            {
                "value": 92.07,
                "count": 1.0
            },
            {
                "value": 92.33,
                "count": 1.0
            },
            {
                "value": 93.28,
                "count": 1.0
            },
            {
                "value": 93.64,
                "count": 1.0
            },
            {
                "value": 93.81,
                "count": 1.0
            },
            {
                "value": 94.2,
                "count": 1.0
            },
            {
                "value": 94.25,
                "count": 1.0
            },
            {
                "value": 94.58,
                "count": 1.0
            },
            {
                "value": 95.7,
                "count": 1.0
            },
            {
                "value": 95.8,
                "count": 1.0
            },
            {
                "value": 96.78,
                "count": 1.0
            },
            {
                "value": 96.94,
                "count": 1.0
            },
            {
                "value": 97.28,
                "count": 1.0
            },
            {
                "value": 97.62,
                "count": 1.0
            },
            {
                "value": 98.54,
                "count": 1.0
            },
            {
                "value": 99.18,
                "count": 1.0
            },
            {
                "value": 99.28,
                "count": 1.0
            },
            {
                "value": 99.3,
                "count": 1.0
            },
            {
                "value": 99.31,
                "count": 1.0
            },
            {
                "value": 99.43,
                "count": 1.0
            },
            {
                "value": 99.45,
                "count": 1.0
            },
            {
                "value": 99.47,
                "count": 1.0
            },
            {
                "value": 99.82,
                "count": 1.0
            },
            {
                "value": 99.85,
                "count": 1.0
            },
            {
                "value": 100.0,
                "count": 1.0
            },
            {
                "value": 102.2,
                "count": 1.0
            },
            {
                "value": 103.13,
                "count": 1.0
            },
            {
                "value": 103.25,
                "count": 1.0
            },
            {
                "value": 103.74,
                "count": 1.0
            },
            {
                "value": 104.99,
                "count": 1.0
            },
            {
                "value": 105.55,
                "count": 1.0
            },
            {
                "value": 106.19,
                "count": 1.0
            },
            {
                "value": 106.39,
                "count": 1.0
            },
            {
                "value": 106.92,
                "count": 1.0
            },
            {
                "value": 107.07,
                "count": 1.0
            },
            {
                "value": 107.67,
                "count": 1.0
            },
            {
                "value": 108.73,
                "count": 1.0
            },
            {
                "value": 109.15,
                "count": 1.0
            },
            {
                "value": 109.22,
                "count": 1.0
            },
            {
                "value": 110.02,
                "count": 1.0
            },
            {
                "value": 110.08,
                "count": 1.0
            },
            {
                "value": 110.15,
                "count": 1.0
            },
            {
                "value": 110.86,
                "count": 1.0
            },
            {
                "value": 111.76,
                "count": 1.0
            },
            {
                "value": 112.63,
                "count": 1.0
            },
            {
                "value": 115.5,
                "count": 1.0
            },
            {
                "value": 116.46,
                "count": 1.0
            },
            {
                "value": 116.97,
                "count": 1.0
            },
            {
                "value": 117.96,
                "count": 2.0
            },
            {
                "value": 119.21,
                "count": 1.0
            },
            {
                "value": 121.28,
                "count": 1.0
            },
            {
                "value": 122.53,
                "count": 1.0
            },
            {
                "value": 122.88,
                "count": 1.0
            },
            {
                "value": 123.68,
                "count": 1.0
            },
            {
                "value": 123.98,
                "count": 1.0
            },
            {
                "value": 124.33,
                "count": 1.0
            },
            {
                "value": 124.42,
                "count": 1.0
            },
            {
                "value": 124.55,
                "count": 2.0
            },
            {
                "value": 124.68,
                "count": 1.0
            },
            {
                "value": 124.7,
                "count": 1.0
            },
            {
                "value": 125.01,
                "count": 1.0
            },
            {
                "value": 125.13,
                "count": 1.0
            },
            {
                "value": 125.37,
                "count": 1.0
            },
            {
                "value": 125.69,
                "count": 1.0
            },
            {
                "value": 125.78,
                "count": 1.0
            },
            {
                "value": 126.39,
                "count": 1.0
            },
            {
                "value": 126.62,
                "count": 1.0
            },
            {
                "value": 127.06,
                "count": 1.0
            },
            {
                "value": 132.28,
                "count": 1.0
            },
            {
                "value": 134.31,
                "count": 1.0
            },
            {
                "value": 135.18,
                "count": 1.0
            },
            {
                "value": 135.41,
                "count": 1.0
            }
        ]
    },
    "group_list": [
        "TESTVIN12345678901"
    ],
    "group_name": "vin"
}




